import {FieldProps} from "formik";

import {
    IbanElement,
    IbanElementProps
} from "@stripe/react-stripe-js";
import {
    Stack,
    Text,
    TextInputProps,
    Title
} from "@mantine/core";
import {StripeIbanElementOptions} from "@stripe/stripe-js";
import classes from "./FormikStripeIban.module.css";

export const FormikStripeIban = ({
                                     field,
                                     form: {setFieldValue},
                                     ...rest
                                 }: FieldProps & IbanElementProps & TextInputProps) => {

    const options = {
        supportedCountries: ['SEPA'],
        // Elements can use a placeholder as an example IBAN that reflects
        // the IBAN format of your customer's country. If you know your
        // customer's country, we recommend that you pass it to the Element as the
        // placeholderCountry.
        placeholderCountry: 'BG',
        classes: classes
    } as StripeIbanElementOptions

    return (
        <Stack gap={'md'} my={'xl'}>
            <Title order={4}><Text>{rest.label}:</Text></Title>
            <IbanElement {...field} {...rest}
                         onChange={value => setFieldValue(field.name, value)}
                         options={options}
            />
        </Stack>
    );
};

